import * as styledElements from "./AuthenticationStyles";
import { THREE_STEP_INFO } from "./constants";
import CircleBadge from "../common/CircleBadge";
import { ButtonVariants } from "../common/Button/constants";
import React from "react";

export default function WhyRegister({ imperative }: { imperative?: boolean }) {
  const descriptiveText = imperative
    ? "Register with FlashPCB to"
    : "Registering with FlashPCB allows you to";
  return (
    <>
      <styledElements.DescriptionText>
        {descriptiveText}:
      </styledElements.DescriptionText>
      <styledElements.ThreeStepContainer>
        {THREE_STEP_INFO.map((step, index) => (
          <styledElements.StepContainer key={step.label}>
            <CircleBadge
              iconProps={{
                src: step.iconInfo.path,
                alt: step.iconInfo.alt,
              }}
              type={ButtonVariants.PRIMARY}
              hasBottomConnector={index != THREE_STEP_INFO.length - 1}
              isLink={false}
            />
            {step.label}
          </styledElements.StepContainer>
        ))}
      </styledElements.ThreeStepContainer>
    </>
  );
}
